exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-128136f0]{font-size:large}#bmrCounter[data-v-128136f0]{height:90vh;transition:.5s ease-in;display:flex;align-items:center;justify-content:center;flex-direction:column}.error[data-v-128136f0]{height:1.5rem;text-align:center}.error span[data-v-128136f0]{color:red}input[data-v-128136f0],option[data-v-128136f0],select[data-v-128136f0]{opacity:.8;text-align:center;color:#000}button[data-v-128136f0]{opacity:.9;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-128136f0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BmrCounter.vue
// module id = 89
// module chunks = 0